<template>
    <v-dialog v-model="dialogChangePassword" width="350">
        <v-card class="pa-3">
            <v-card-title class="pt-2 pl-1 pb-1 pl-7">
                <span class="text-h5">{{ $t('menu.changePassword') }}</span>
                <v-spacer></v-spacer>
                <v-btn tag="a" icon @click="dialogChangePassword = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <AppForm ref="changePasswordForm" @keyup.native.enter="changePassword" class="pl-4 pr-4">
                <v-card-text class="pb-0">
                    <v-container class="pl-0 pr-0">
                        <v-row>
                            <v-col cols="12" class="pl-2 pr-2 pt-0 pb-0">
                                <v-text-field
                                    type="password"
                                    :label="$t('menu.currentPassword')"
                                    v-model="password"
                                    :rules="rules.password"
                                    color="grey"
                                    class="pt-0 pb-0"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="pl-2 pr-2 pt-0 pb-0">
                                <v-text-field
                                    type="password"
                                    :label="$t('menu.password')"
                                    v-model="newPassword"
                                    :rules="rules.newPassword"
                                    color="grey"
                                    class="pt-0 pb-0"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="pl-2 pr-2 pt-0 pb-0">
                                <v-text-field
                                    type="password"
                                    :label="$t('menu.confirmPassword')"
                                    v-model="confirmPassword"
                                    :rules="rules.confirmPassword"
                                    color="grey"
                                    class="pt-0 pb-0"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </AppForm>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn tag="a" :loading="loading" :disabled="loading" color="tbGreen" style="color: white" elevation="0" @click="changePassword">
                    {{ $t('action.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<style scoped></style>
<script>
    import AppForm from 'Pages/core/form/AppForm';
    import { mapGetters } from 'vuex';
    import store from '~/store';

    export default {
        name: 'app-menuAccountChangePasswordDialog',
        components: {
            AppForm,
        },
        data() {
            return {
                loading: false,
                dialogChangePassword: false,
                rules: {
                    password: [(v) => !!v || store.$i18n.t('rules.required')],
                    newPassword: [(v) => !!v || store.$i18n.t('rules.required')],
                    confirmPassword: [
                        (v) => !!v || store.$i18n.t('rules.required'),
                        (v) => {
                            if (v && store.getters['UserModule/getNewPassword']) {
                                return v !== store.getters['UserModule/getNewPassword'] ? store.$i18n.t('rules.newPasswordDoesNotMatch') : true;
                            }
                            return true;
                        },
                    ],
                },
            };
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            open() {
                if (this.$refs.changePasswordForm) {
                    this.$refs.changePasswordForm.$refs.form.reset();
                    this.$refs.changePasswordForm.$refs.form.resetValidation();
                }
                this.dialogChangePassword = true;
            },

            changePassword() {
                let validationResult = this.$refs.changePasswordForm.$refs.form.validate();
                if (validationResult) {
                    this.loading = true;
                    let params = {
                        password: this.password,
                        newPassword: this.newPassword,
                        newPassword_confirmation: this.confirmPassword,
                    };

                    this.$store.dispatch('UserModule/changePassword', params).then((response) => {
                        if (response.data.success) {
                            this.password = '';
                            this.newPassword = '';
                            this.confirmPassword = '';
                            this.dialogChangePassword = false;
                        }

                        this.loading = false;
                    });
                }
            },
        },

        computed: {
            ...mapGetters({
                // getTimeZone: 'DictionariesModule/getTimeZone',
            }),

            user() {
                return this.$store.getters['UserModule/getUser'];
            },

            password: {
                get() {
                    return this.$store.getters['UserModule/getPassword'];
                },
                set(value) {
                    this.$store.commit('UserModule/setPassword', value);
                },
            },

            newPassword: {
                get() {
                    return this.$store.getters['UserModule/getNewPassword'];
                },
                set(value) {
                    this.$store.commit('UserModule/setNewPassword', value);
                },
            },
            confirmPassword: {
                get() {
                    return this.$store.getters['UserModule/getConfirmPassword'];
                },
                set(value) {
                    this.$store.commit('UserModule/setConfirmPassword', value);
                },
            },
        },
    };
</script>
